'use client';

import { c as _c } from "react/compiler-runtime";
import { EventName } from '../Shibuya';
import { useAnalytics } from './useAnalytics';
type TrackElementInteractedParams = {
  entityName: string;
  parentEventId: string;
  interactionType: string;
  itemCopy?: string;
  additionalAttributes?: Record<string, unknown>;
};
export function useTrackElementInteracted() {
  const $ = _c(5);
  const {
    analytics,
    deployableName,
    deployableVersion,
    gitSha
  } = useAnalytics();
  let t0;
  if ($[0] !== analytics || $[1] !== deployableName || $[2] !== deployableVersion || $[3] !== gitSha) {
    t0 = t1 => {
      const {
        entityName,
        parentEventId,
        interactionType,
        itemCopy,
        additionalAttributes
      } = t1;
      if (!analytics) {
        return;
      }
      analytics.track(EventName.ELEMENT_INTERACTED, {
        entity_name: entityName,
        parent_event_id: parentEventId,
        interaction_type: interactionType,
        item_copy: itemCopy,
        additional_attributes: additionalAttributes,
        deployable_name: deployableName,
        deployable_version: deployableVersion
      }, {
        context: {
          app: {
            name: deployableName,
            version: gitSha
          }
        }
      });
    };
    $[0] = analytics;
    $[1] = deployableName;
    $[2] = deployableVersion;
    $[3] = gitSha;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}